var map = {
	"./template.betprofessor": 1513,
	"./template.betprofessor.tsx": 1513,
	"./template.betroyale": 1514,
	"./template.betroyale.tsx": 1514,
	"./template.default": 667,
	"./template.default.tsx": 667,
	"./template.fiestabet": 1515,
	"./template.fiestabet.tsx": 1515,
	"./template.goldenbet888": 1516,
	"./template.goldenbet888.tsx": 1516,
	"./template.goldrenrush": 1517,
	"./template.goldrenrush.tsx": 1517,
	"./template.puntcity": 1518,
	"./template.puntcity.tsx": 1518,
	"./template.puntgenie": 1519,
	"./template.puntgenie.tsx": 1519,
	"./template.questbet": 1520,
	"./template.questbet.tsx": 1520,
	"./template.sterlingparker": 1521,
	"./template.sterlingparker.tsx": 1521,
	"./template.ts": 981,
	"./template.vikingbet": 1522,
	"./template.vikingbet.tsx": 1522,
	"./template.volcanobet": 1523,
	"./template.volcanobet.tsx": 1523,
	"./template.wellbet": 1524,
	"./template.wellbet.tsx": 1524
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2443;